import React, { PureComponent } from 'react'
import {
    ShimmeredDetailsList, SelectionMode, DetailsListLayoutMode, ConstrainMode, buildColumns, Text,
} from '@fluentui/react'
import history from 'helpers/history'
import { handleRenderColumn, onColumnClick } from 'helpers/methods/common'
import Status from 'types/status'
import EmailTemplate from 'requests/objects/emailTemplate'
import { Link } from 'react-router-dom'
import InvalidEntityError from 'requests/errors/invalidEntityError'
import CancelRequestError from 'requests/errors/cancelRequestError'
import NotImplementedError from 'requests/errors/notImplementedError'
import UnauthorizedError from 'requests/errors/unauthorizedError'
import flattenObj from 'helpers/methods/flattenObj'
import Card from 'components/containers/card'
import styles from 'styles/pages/modele-emails/index.module.scss'
import { NEW_PATH } from 'types/others'
import emailTemplateColumns from 'types/modele-emails/columns'

/**
 * @typedef {object} SearchParamsType
 * @property {string} example example
 */

/**
 * @augments {PureComponent<import('app').AppProps>} extends
 */
export default class IndexEmailTemplates extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            /** @type {Status} Current status of the component */
            status: Status.IDLE,
            /** @type {import('@fluentui/react').IColumn[]} Columns displayed */
            columns: [],
            /** @type {EmailTemplate[]} Items found in API */
            items: [],
            /** @type {EmailTemplate[]} Initial items found in API */
            iniItems: [],
            /** @type {SearchParamsType} Params to search */
            searchParams: {
                example: null,
            },
        }

        /** @type {NodeJS.Timeout} Time out to handle apply of searchParams */
        this.timeOutParams = null
    }

    /**
     * @inheritdoc
     */
    componentDidMount() {
        this.init()

        this.search()
    }

    /**
     * @inheritdoc
     * @param {object} prevProps Previous Props
     * @param {object} prevState Previous State
     */
    componentDidUpdate(prevProps, prevState) {
        const { searchParams } = this.state

        if (JSON.stringify(prevState.searchParams) !== JSON.stringify(searchParams)) {
            // Apply changement with delay to prevent lag
            clearTimeout(this.timeOutParams)
            this.timeOutParams = setTimeout(() => {
                history.replace({ search: '' })
                this.syncSearchParamsInHistory()
            }, 250)
        }
        // this.init()

        // this.setupBreadcrumb()

        // this.setupCommandBar()

        // this.setState({
        //     columns: this.buildColumns(),
        // })
    }

    /**
     * @inheritdoc
     */
    componentWillUnmount() {
        this.emailTemplatesHandlerGetAll?.cancel()
    }

    /**
     * Setup breadcrumb elements
     */
    setupBreadcrumb() {
        const { setBreadcrumb, setTitle } = this.props

        setBreadcrumb([
            { text: 'Saisie modèle email', key: ' modele-email' },
            { text: 'Tous les modèles emails', key: 'all-modele-emails', isCurrentItem: true },
        ])
        setTitle('Modèles emails')
    }

    /**
     * Setup commandbar elements
     */
    setupCommandBar() {
        const { setCommand } = this.props

        setCommand(
            [
                {
                    key: 'new',
                    text: 'Nouveau',
                    iconProps: { iconName: 'Add' },
                    onClick: () => history.push(`/modele-emails/${NEW_PATH}`),
                    disabled: false,
                },
            ],
        )
    }

    /**
     * Sync SearchParams in navigation history
     */
    syncSearchParamsInHistory() {
        const { searchParams } = this.state

        const queryParams = new URLSearchParams(window.location.search)

        // eslint-disable-next-line no-restricted-syntax
        for (const key in searchParams)
            if (searchParams[key] !== null && searchParams[key] !== '' && searchParams[key]?.length !== 0)
                if (Array.isArray(searchParams[key]))
                    // eslint-disable-next-line no-restricted-syntax
                    for (const element of searchParams[key])
                        queryParams.append(key, element)
                else
                    queryParams.set(key, searchParams[key])
            else
                queryParams.delete(key)

        history.replace({
            search: queryParams.toString(),
        })
    }

    /**
     * Init Page
     */
    init() {
        const { setMessageBar, setCommand } = this.props

        setMessageBar({ isDisplayed: false })
        setCommand([])

        this.setupBreadcrumb()
        this.setupCommandBar()

        if (!window.location.search) {
            this.syncSearchParamsInHistory()
        } else {
            const queryParams = new URLSearchParams(window.location.search)

            // Reset Filter
            this.setState({
                /** @type {SearchParamsType} */
                searchParams: {
                    example: queryParams.get('example') || null,
                },
            }, () => this.syncSearchParamsInHistory())
        }
    }

    /**
     * Init <DetailList>
     * @returns {import('@fluentui/react').IColumn[]} Columns
     */
    buildColumns() {
        const cols = emailTemplateColumns?.reduce((obj, col) => ({ ...obj, [col.fieldName]: col.name }), {})

        const columns = buildColumns(
            [cols],
            true,
            this.onColumnClick.bind(this, {
                colName: 'columns', dataName: ['items'], source: 'state', isFlatten: true,
            }),
        )

        // eslint-disable-next-line no-restricted-syntax
        for (const column of columns) {
            column.name = cols[column.name]
            column.maxWidth = (() => {
                switch (column.name) {
                    case 'Nom':
                    case 'Sujet':
                        return 300
                    default:
                        return (column.name?.length ?? 1) * 12
                }
            })()
            column.minWidth = (column.name?.length ?? 1) * 5
            // eslint-disable-next-line max-len
            column.onRender = emailTemplateColumns.find(x => x.name === column.name)?.onRender ?? this.handleRenderColumn(emailTemplateColumns, column.name, column)
        }

        return columns
    }

    /**
     * Search elements
     */
    search() {
        this.setState({
            status: Status.PENDING,
            columns: this.buildColumns(),
        }, async () => {
            const { emailTemplatesHandler, setBreadcrumb } = this.props
            const { searchParams } = this.state
            setBreadcrumb([
                { text: 'Saisie modèle email', key: ' modele-email' },
                { text: 'Tous les modèles emails', key: 'all-modele-emails', isCurrentItem: true },
            ])
            try {
                this.emailTemplatesHandlerGetAll = emailTemplatesHandler.getAll(searchParams)
                const emailTemplates = await this.emailTemplatesHandlerGetAll.fetch()
                this.setState({
                    items: emailTemplates.map(x => this.flattenObj(x)),
                    iniItems: emailTemplates,
                    status: Status.RESOLVED,
                })
                setBreadcrumb([
                    { text: 'Saisie modèle email', key: ' modele-email' },
                    { text: `Tous les modèles emails (${emailTemplates.length || 0})`, key: 'all-modele-emails', isCurrentItem: true },
                ])
            } catch (error) {
                switch (error?.constructor) {
                    case CancelRequestError:
                    case UnauthorizedError:
                    case InvalidEntityError: break
                    case NotImplementedError:
                        // eslint-disable-next-line no-console
                        console.error(error)
                        break
                    default:
                        this.setState({
                            items: [],
                            iniItems: [],
                            status: Status.REJECTED,
                        })
                        // eslint-disable-next-line no-console
                        console.error(error)
                        break
                }
            }
        })
    }

    /**
     * Render component
     * @returns {JSX.Element} Element
     */
    render() {
        const {
            columns, status, items,
            iniItems, // eslint-disable-line no-unused-vars
        } = this.state

        return (
            <Card className={styles.index}>
                <ShimmeredDetailsList
                    items={items}
                    columns={columns}
                    selectionMode={SelectionMode.none}
                    onShouldVirtualize={() => true}
                    enableShimmer={status === Status.PENDING}
                    layoutMode={DetailsListLayoutMode.justified}
                    constrainMode={ConstrainMode.unconstrained}
                    onRenderDetailsHeader={(props, defaultRender) => defaultRender({ ...props, styles: { root: { paddingTop: 0 } } })}
                    // eslint-disable-next-line react/no-unstable-nested-components
                    onRenderRow={(props, defaultRender) => (
                        <Link
                            to={{
                                pathname: `/modele-emails/${props.item?.emailTemplateId}`,
                                // state: {
                                //     emailTemplate: iniItems.find(x => x.emailTemplateId === props.item?.emailTemplateId),
                                // },
                            }}
                        >
                            {defaultRender(props)}
                        </Link>
                    )}

                />
                {!items?.length && [Status.RESOLVED, Status.REJECTED].includes(status)
                    && <Text styles={{ root: { fontStyle: 'italic', marginLeft: '1em' } }}>Aucun résultat trouvé</Text>}
            </Card>
        )
    }
}

IndexEmailTemplates.prototype.onColumnClick = onColumnClick
IndexEmailTemplates.prototype.flattenObj = flattenObj
IndexEmailTemplates.prototype.handleRenderColumn = handleRenderColumn
